// extracted by mini-css-extract-plugin
export var content = "_6-3";
export var footer = "_6-4";
export var header = "_6-1";
export var panel = "_6-0";
export var tabsWrapper = "_6-2";